import {
  SubscriptionLevels,
  SubscriptionOptionsTypes,
} from "@fena/toolkit-types";

export enum SubscriptionFrequencies {
  MONTHLY = "month",
  ANNUALLY = "year",
}

export enum SubscriptionLevelEnum {
  BASIC = "BASIC",
  STARTER = "STARTER",
  SCALE_UP = "SCALE_UP",
  PROFESSIONAL = "PROFESSIONAL",
  ENTERPRISE = "ENTERPRISE",
  PAYMENTS_ONLY = "PAYMENTS_ONLY",
}

export enum SubscriptionOptionEnum {
  TOOLKIT = "TOOLKIT",
  PAYMENTS_ONLY = "PAYMENTS_ONLY",
  SHOPIFY_B2B_SUBSCRIPTION = "SHOPIFY_B2B_SUBSCRIPTION",
}

export enum ChoosePlanActions {
  UPGRADE_OR_DOWNGRADE_EXISTING = "UPGRADE_OR_DOWNGRADE",
  CREATE = "CREATE",
  GET_ADD_ON = "GETADDON",
  GET_SALE_AGENT_SEAT = "GETSEAT",
}

export interface Limits {
  integrationsLimit: number;
  otherPayments: boolean;
  paymentsLimit: number;
  productsLimit: number;
  usersLimit: number;
}

export interface SubscriptionStats {
  active_limit_integrations: number;
  active_limit_payments: number;
  active_limit_products: number;
  active_limit_users: number;
  external_integrations_count: number;
  has_subscription: boolean;
  period_payments_count: number;
  products_count: number;
  users_count: number;
}

export interface SelectedPlanData {
  price?: number | string;
  priceId?: string;
  extensionPackId?: string;
  value?: string | number;
  action?: ChoosePlanActions;
  name?: SubscriptionLevels | SubscriptionOptionEnum;
  option?: SubscriptionOptionsTypes;
  interval?: string;
  buySalesAgent?: boolean;
}

export interface SubscriptionTier {
  flat_amount: number;
  flat_amount_decimal: string;
  unit_amount: number;
  unit_amount_decimal: string;
  up_to: number;
}
